import $ from 'jquery';
import { validate } from 'email-validator';

const CommonActions = {
    validateOEMType: (oemType: string, reeferData: any[]) => {
        var DaikinCount = 0;
        if (reeferData.length > 0) {
            var OEMTypeCdCount = 0;

            $.each(reeferData, function (key, value) {
                if (value.ReeferOEMTypeCd.trim() == oemType) {
                    DaikinCount++;
                }
            });
        }

        return DaikinCount;
    },
    validateSpecificOEMTypeForCommand: (oemType: string, commandType: string, reeferData: any[], reeferConfigTypes: any) => {
        var DaikinCount = 0;
        if (reeferData.length > 0) {
            $.each(reeferData, function (key, value) {
                if (value.ReeferOEMTypeCd.trim() == oemType) {
                    if (reeferConfigTypes != null && reeferConfigTypes != undefined) {
                        if ((reeferConfigTypes.RefCommandSupports != null && reeferConfigTypes.RefCommandSupports != undefined && reeferConfigTypes.RefCommandSupports.length > 0) && (reeferConfigTypes.RefReeferConfigTypes != null && reeferConfigTypes.RefReeferConfigTypes != undefined && reeferConfigTypes.RefReeferConfigTypes.length > 0)) {
                            var resultReeferConfigType = reeferConfigTypes.RefReeferConfigTypes.filter(obj => {
                                return obj.ReeferConfigTypeCd === value.ReeferConfigTypeCd
                            });

                            if (resultReeferConfigType != null && resultReeferConfigType != undefined && resultReeferConfigType.length > 0) {
                                var resultReeferCommandType = reeferConfigTypes.RefCommandSupports.filter(obj => {
                                    return obj.ReeferConfigTypeID === resultReeferConfigType[0].ReeferConfigTypeId
                                });

                                if (resultReeferCommandType != null && resultReeferCommandType != undefined && resultReeferCommandType.length > 0) {
                                    var resultReeferCommandTypeSubList = resultReeferCommandType.filter(obj => {
                                        return obj.CommandTypeCd === commandType && obj.IsActive === true
                                    });

                                    $.each(resultReeferCommandType, function (i, val) {
                                        if (val.CommandTypeCD == commandType && val.IsActive == true) {
                                            DaikinCount++;
                                        }
                                    });
                                }
                            }
                        }
                    }
                }
            });
        }

        return DaikinCount;
    },
    validateCommandSupport: (commandType: string, reeferData: any[], reeferConfigTypes: any) => {
        var IsValid = true;
        if (reeferData.length > 0) {
            $.each(reeferData, function (key, value) {
                if (IsValid == true) {
                    if (reeferConfigTypes != null && reeferConfigTypes != undefined) {
                        if ((reeferConfigTypes.RefCommandSupports != null && reeferConfigTypes.RefCommandSupports != undefined && reeferConfigTypes.RefCommandSupports.length > 0) && (reeferConfigTypes.RefReeferConfigTypes != null && reeferConfigTypes.RefReeferConfigTypes != undefined && reeferConfigTypes.RefReeferConfigTypes.length > 0)) {
                            var resultReeferConfigType = reeferConfigTypes.RefReeferConfigTypes.filter(obj => {
                                return obj.ReeferConfigTypeCd === value.ReeferConfigTypeCd
                            });

                            if (resultReeferConfigType != null && resultReeferConfigType != undefined && resultReeferConfigType.length > 0) {
                                var resultReeferCommandType = reeferConfigTypes.RefCommandSupports.filter(obj => {
                                    return obj.ReeferConfigTypeID === resultReeferConfigType[0].ReeferConfigTypeId
                                });

                                if (resultReeferCommandType != null && resultReeferCommandType != undefined && resultReeferCommandType.length > 0) {
                                    var resultReeferCommandTypeSubList = resultReeferCommandType.filter(obj => {
                                        return obj.CommandTypeCD === commandType
                                    });
                                    if (resultReeferCommandTypeSubList != null && resultReeferCommandTypeSubList != undefined && resultReeferCommandTypeSubList.length > 0) {
                                        $.each(resultReeferCommandTypeSubList, function (i, val) {
                                            if (val.IsActive == true) {
                                                IsValid = true;
                                            }
                                            else {
                                                IsValid = false;
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            });
        }
        return IsValid;
    },
    validateAssociation: (reeferData: any[]) => {
        var ValidCount = 0;
        var IsValid = true;
        if (reeferData.length > 0) {
            $.each(reeferData, function (key, value) {
                if (value.RCDMasterID != null && value.RCDMasterID != undefined && value.RCDMasterID > 0)
                    ValidCount++;
            });
            if (ValidCount == reeferData.length)
                IsValid = true;
            else
                IsValid = false;
        }
        return IsValid;
    },
    validateAllOEMs: (reeferData: any[]) => {
        var validateObject = { Message: "", OpenCommandWindow: true, OEM: '' }

        if (reeferData.length > 0) {
            var OEMTypeCdCount = 0;
            var Starcoolcount = 0;
            var DaikinCount = 0;
            var CarrierCount = 0;
            var ThermokingCount = 0;
            var TKReceiverCount = 0;
            var UnknownCount = 0;
            $.each(reeferData, function (key, value) {
                if (value.ReeferOEMTypeCd == null || value.ReeferOEMTypeCd == undefined) {
                    OEMTypeCdCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "S") {
                    Starcoolcount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "D") {
                    DaikinCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "C") {
                    CarrierCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "T") {
                    ThermokingCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "TR") {
                    TKReceiverCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "U") {
                    UnknownCount++;
                }
            });

            if (OEMTypeCdCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (Starcoolcount == reeferData.length || CarrierCount == reeferData.length || TKReceiverCount == reeferData.length || DaikinCount == reeferData.length || ThermokingCount == reeferData.length) {
                validateObject.Message = "";
                validateObject.OpenCommandWindow = true;
                validateObject.OEM = '';
            }
            else {
                validateObject.Message = "Selected reefers must be of the same OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
        }

        return validateObject;
    },
    validateDLCommand: (reeferData: any[]) => {
        var validateObject = { Message: "", OpenCommandWindow: true, OEM: '', DeviceType: '' }
        if (reeferData.length > 0) {
            var OEMTypeCdCount = 0;
            var Starcoolcount = 0;
            var DaikinCount = 0;
            var CarrierCount = 0;
            var ThermokingCount = 0;
            var TKReceiverCount = 0;
            var UnknownCount = 0;
            var MP4Count = 0;
            var CT3000 = 0;
            var RCU = 0;
            var CT5000 = 0;
            var CT4000 = 0;
            var CT3100 = 0;
            var CT3500 = 0;
            var TripLINK = 0;
            var DeviceTypeCdCount = 0;
            var CarrierCount = 0;
            var CT3600 = 0;
            $.each(reeferData, function (key, value) {
                if (value.ReeferOEMTypeCd == null || value.ReeferOEMTypeCd == undefined) {
                    OEMTypeCdCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "S") {
                    Starcoolcount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "D") {
                    DaikinCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "C") {
                    CarrierCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "T") {
                    ThermokingCount++;
                    if (value.UnitTypeCd == "TR")
                        MP4Count++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "TR") {
                    TKReceiverCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "U") {
                    UnknownCount++;
                }
            });

            if (OEMTypeCdCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (Starcoolcount == reeferData.length || CarrierCount == reeferData.length || DaikinCount == reeferData.length || ThermokingCount == reeferData.length) {
                if (ThermokingCount == reeferData.length) { //WI 24753
                    if (MP4Count > 0) {
                        if (MP4Count == reeferData.length) {
                            validateObject.Message = "";
                            validateObject.OpenCommandWindow = true;
                            validateObject.OEM = '';
                        }
                        else {
                            validateObject.Message = "Selected reefers must be of the same OEM Model.";
                            validateObject.OpenCommandWindow = false;
                            validateObject.OEM = '';
                        }
                    }
                    else {
                        validateObject.Message = "";
                        validateObject.OpenCommandWindow = true;
                        validateObject.OEM = '';
                    }
                }
                else {
                    //validateObject.Message = "";
                    //validateObject.OpenCommandWindow = true;
                    //validateObject.OEM = '';
                    $.each(reeferData, function (key, value) {
                        if (value.DeviceType == null && value.DeviceType == undefined) {
                            DeviceTypeCdCount++;
                        }
                        else if (value.ReeferOEMTypeCd.trim() == "C") {
                            if (value.DeviceType.trim() == "RCU") {
                                RCU++;
                            }
                            else if (value.DeviceType.trim() == "CT3000") {
                                CT3000++;
                            }
                            else if (value.DeviceType.trim() == "CT3100") {
                                CT3100++;
                            }
                            else if (value.DeviceType.trim() == "CT4000") {
                                CT4000++;
                            }
                            else if (value.DeviceType.trim() == "CT5000") {
                                CT5000++;
                            }
                            else if (value.DeviceType.trim() == "CT3500") {
                                CT3500++;
                            }
                            //WI-RCNG-3349
                            else if (value.DeviceType.trim().toUpperCase() == "TRIPLINK") {
                                TripLINK++;
                            }
                            else if (value.DeviceType.trim().toUpperCase() == "CT3600") {
                                CT3600++;
                            }
                            CarrierCount++;
                        }
                    });

                    if (DeviceTypeCdCount > 0) {
                        validateObject.Message = "Selected reefer(s) must have a valid Device type.";
                        validateObject.OpenCommandWindow = false;
                        validateObject.DeviceType = '';
                    }

                    else if (CarrierCount > 0 && (!(RCU == reeferData.length || CT3000 == reeferData.length || CT3100 == reeferData.length
                        || CT5000 == reeferData.length || CT4000 == reeferData.length || CT3500 == reeferData.length || TripLINK == reeferData.length
                        || CT3600 == reeferData.length))) {
                        validateObject.Message = "Selected reefers must be of the same Device type.";
                        validateObject.OpenCommandWindow = false;
                        validateObject.DeviceType = '';
                    }
                    else {
                        validateObject.Message = "";
                        validateObject.OpenCommandWindow = true;
                        validateObject.DeviceType = '';
                    }
                }
            }
            else if (TKReceiverCount == reeferData.length) {
                validateObject.Message = "Command is not supported for TKReceiver OEM.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (UnknownCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else {
                validateObject.Message = "Selected reefers must be of the same OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
        }

        return validateObject;
    },
    validateMultipleOEMs: (reeferData: any[]) => {
        var validateObject = { Message: "", OpenCommandWindow: true, OEM: '' }

        if (reeferData.length > 0) {
            var OEMTypeCdCount = 0;
            var Starcoolcount = 0;
            var DaikinCount = 0;
            var CarrierCount = 0;
            var ThermokingCount = 0;
            var UnknownCount = 0;
            $.each(reeferData, function (key, value) {
                if (value.ReeferOEMTypeCd == null || value.ReeferOEMTypeCd == undefined) {
                    OEMTypeCdCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "S") {
                    Starcoolcount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "D") {
                    DaikinCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "C") {
                    CarrierCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "T") {
                    ThermokingCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "U") {
                    UnknownCount++;
                }
            });

            if (OEMTypeCdCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (Starcoolcount == reeferData.length || CarrierCount == reeferData.length || DaikinCount == reeferData.length || ThermokingCount == reeferData.length) {
                validateObject.Message = "";
                validateObject.OpenCommandWindow = true;
                validateObject.OEM = '';
            }
            else {
                validateObject.Message = "Selected reefers must be of the same OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
        }

        return validateObject;
    },
    validateCarrierDaikinThermoKingTypes: (reeferData: any[]) => {
        var validateObject = { Message: "", OpenCommandWindow: true, OEM: '' }

        if (reeferData.length > 0) {
            var OEMTypeCdCount = 0;
            var Starcoolcount = 0;
            var DaikinCount = 0;
            var CarrierCount = 0;
            var ThermokingCount = 0;
            var UnknownCount = 0;
            $.each(reeferData, function (key, value) {
                if (value.ReeferOEMTypeCd == null || value.ReeferOEMTypeCd == undefined) {
                    OEMTypeCdCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "S") {
                    Starcoolcount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "D") {
                    DaikinCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "C") {
                    CarrierCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "T") {
                    ThermokingCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "U") {
                    UnknownCount++;
                }
            });

            if (OEMTypeCdCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (Starcoolcount == reeferData.length) {
                validateObject.Message = "";
                validateObject.OpenCommandWindow = true;
                validateObject.OEM = '';
            }
            else if (CarrierCount == reeferData.length || DaikinCount == reeferData.length || ThermokingCount == reeferData.length) {
                validateObject.Message = "Command is supported for Starcool OEM only.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else {
                validateObject.Message = "Selected reefers must be of the same OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
        }

        return validateObject;
    },
    validateStarCoolCarrierDaikinTypes: (reeferData: any[]) => {
        var validateObject = { Message: "", OpenCommandWindow: true, OEM: '' }
        if (reeferData.length > 0) {
            var OEMTypeCdCount = 0;
            var Starcoolcount = 0;
            var DaikinCount = 0;
            var CarrierCount = 0;
            var ThermokingCount = 0;
            var UnknownCount = 0;
            $.each(reeferData, function (key, value) {
                if (value.ReeferOEMTypeCd == null || value.ReeferOEMTypeCd == undefined) {
                    OEMTypeCdCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "S") {
                    Starcoolcount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "D") {
                    DaikinCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "C") {
                    CarrierCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "T") {
                    ThermokingCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "U") {
                    UnknownCount++;
                }
            });

            if (OEMTypeCdCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (Starcoolcount == reeferData.length || CarrierCount == reeferData.length || DaikinCount == reeferData.length) {
                validateObject.Message = "";
                validateObject.OpenCommandWindow = true;
                validateObject.OEM = '';
            }
            else if (ThermokingCount == reeferData.length) {
                validateObject.Message = "Command is not supported for Thermoking OEMs.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (UnknownCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else {
                validateObject.Message = "Selected reefers must be of the same OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
        }

        return validateObject;
    },
    validateDaikinTypes: (reeferData: any[]) => {
        var validateObject = { Message: "", OpenCommandWindow: true, OEM: '' }
        if (reeferData.length > 0) {
            var OEMTypeCdCount = 0;
            var Starcoolcount = 0;
            var DaikinCount = 0;
            var CarrierCount = 0;
            var ThermokingCount = 0;
            var TKReceiverCount = 0;
            var UnknownCount = 0;
            $.each(reeferData, function (key, value) {
                if (value.ReeferOEMTypeCd == null || value.ReeferOEMTypeCd == undefined) {
                    OEMTypeCdCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "S") {
                    Starcoolcount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "D") {
                    DaikinCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "C") {
                    CarrierCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "T") {
                    ThermokingCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "TR") {
                    TKReceiverCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "U") {
                    UnknownCount++;
                }
            });

            if (OEMTypeCdCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (DaikinCount == reeferData.length) {
                validateObject.Message = "";
                validateObject.OpenCommandWindow = true;
                validateObject.OEM = 'D';
            }
            else if (Starcoolcount == reeferData.length || CarrierCount == reeferData.length || ThermokingCount == reeferData.length) {
                validateObject.Message = "Command is not supported for Carrier, Starcool and Thermoking OEMs.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (UnknownCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else {
                validateObject.Message = "Selected reefers must be of the same OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
        }

        return validateObject;
    },
    validateDaikinDimiTypes: (reeferData: any[]) => {
        var validateObject = { Message: "", OpenCommandWindow: true, OEM: '' }
        if (reeferData.length > 0) {
            var OEMTypeCdCount = 0;
            var Starcoolcount = 0;
            var DaikinCount = 0;
            var CarrierCount = 0;
            var ThermokingCount = 0;
            var TKReceiverCount = 0;
            var UnknownCount = 0;
            var IsValidCount = 0;
            $.each(reeferData, function (key, value) {
                if (value.ReeferOEMTypeCd == null || value.ReeferOEMTypeCd == undefined) {
                    OEMTypeCdCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "S") {
                    Starcoolcount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "D") {
                    DaikinCount++;
                    if (value.UnitTypeCd != null && value.UnitTypeCd.trim().toUpperCase() == 'DA') {
                        var strFirstTwo = value.SoftwareRevision.substring(0, 2);
                        var strSoftwarehex = value.SoftwareRevision.substring(2, 4);
                        var number = Number("0x" + strSoftwarehex) 
                        if( parseInt(strFirstTwo)==30 && 77<=parseInt(number.toString()))
                        IsValidCount++
                    }
                    else if (value.UnitTypeCd != null && value.UnitTypeCd.trim().toUpperCase() == 'DB') {
                        var strFirstTwo = value.SoftwareRevision.substring(0, 2);
                        var strSoftwarehex = value.SoftwareRevision.substring(2, 4);
                        var number = Number("0x" + strSoftwarehex) 
                        if (parseInt(strFirstTwo) == 31 && 6 <= parseInt(number.toString()))
                        IsValidCount++
                    }
                    //if (value.UnitTypeCd != null && value.UnitTypeCd.trim().toUpperCase() == 'DV') {
                    //        IsValidCount++
                    //}
                }
                else if (value.ReeferOEMTypeCd.trim() == "C") {
                    CarrierCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "T") {
                    ThermokingCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "TR") {
                    TKReceiverCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "U") {
                    UnknownCount++;
                }
            });

            if (OEMTypeCdCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (reeferData.length > 1 && DaikinCount == reeferData.length) {
                if (DaikinCount == IsValidCount || IsValidCount == 0) {
                    validateObject.Message = "";
                    validateObject.OpenCommandWindow = true;
                    validateObject.OEM = 'D';
                }
                else {
                    validateObject.Message = "Selected reefers must be of the same software version/Controller.";
                    validateObject.OpenCommandWindow = false;
                    validateObject.OEM = '';
                }
            }
            else if (DaikinCount == reeferData.length){
                validateObject.Message = "";
                validateObject.OpenCommandWindow = true;
                validateObject.OEM = 'D';
            }
            else if (Starcoolcount == reeferData.length || CarrierCount == reeferData.length || ThermokingCount == reeferData.length) {
                validateObject.Message = "Command is not supported for Carrier, Starcool and Thermoking OEMs.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (UnknownCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else {
                validateObject.Message = "Selected reefers must be of the same OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
        }

        return validateObject;
    },
    validateDaikinThermoKingTypes: (reeferData: any[]) => {
        var validateObject = { Message: "", OpenCommandWindow: true, OEM: '' }
        if (reeferData.length > 0) {
            var OEMTypeCdCount = 0;
            var Starcoolcount = 0;
            var DaikinCount = 0;
            var CarrierCount = 0;
            var ThermokingCount = 0;
            var TKReceiverCount = 0;
            var UnknownCount = 0;
            $.each(reeferData, function (key, value) {
                if (value.ReeferOEMTypeCd == null || value.ReeferOEMTypeCd == undefined) {
                    OEMTypeCdCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "S") {
                    Starcoolcount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "D") {
                    DaikinCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "C") {
                    CarrierCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "T") {
                    ThermokingCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "TR") {
                    TKReceiverCount++;
                }
                else if (value.ReeferOEMTypeCd.trim() == "U") {
                    UnknownCount++;
                }
            });

            if (OEMTypeCdCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (Starcoolcount == reeferData.length || CarrierCount == reeferData.length) {
                validateObject.Message = "";
                validateObject.OpenCommandWindow = true;
                validateObject.OEM = Starcoolcount == reeferData.length ? 'S' : 'C';
            }
            else if (DaikinCount == reeferData.length || ThermokingCount == reeferData.length) {
                validateObject.Message = "Command is not supported for Daikin and Thermoking OEMs.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else if (UnknownCount > 0) {
                validateObject.Message = "Selected reefer(s) must have a valid OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
            else {
                validateObject.Message = "Selected reefers must be of the same OEM type.";
                validateObject.OpenCommandWindow = false;
                validateObject.OEM = '';
            }
        }

        return validateObject;
    }
}

export default CommonActions;